<template>
  <div class="menu_container">
    <div class="menu_wrapper">
      <ul class="menu_ul">
        <router-link to="/home" tag="li" class="menu_item">首页</router-link>
        <router-link to="/about" tag="li" class="menu_item">关于甲申</router-link>
        <router-link to="/trends" tag="li" class="menu_item">信息动态</router-link>
        <router-link to="/project" tag="li" class="menu_item">服务项目</router-link>
        <router-link v-if="false" to="/search" tag="li" class="menu_item">综合查询</router-link>
        <router-link to="/recruitment" tag="li" class="menu_item">人才招聘</router-link>
        <router-link to="/contact" tag="li" class="menu_item">联系我们</router-link>
        <li v-if="true" class="menu_network">
          <el-dropdown>
            <span class="el-dropdown-link">
              <span style="color: #fff;">
                <i class="el-icon-arrow-down el-icon--right"></i>
                网点
              </span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in netWork"
                :key="index"
              >
                <router-link
                  style="color: #333;text-decoration: none;"
                  :to="item.path"
                >
                  {{ item.name }}
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsMenu',
  data () {
    return {
      netWork: [{
        name: '上海',
        path: '/branch/shanghai'
      }, {
        name: '大连',
        path: '/branch/dalian'
      }, {
        name: '青岛',
        path: '/branch/qingdao'
      }, {
        name: '烟台',
        path: '/branch/yantai'
      }, {
        name: '天津',
        path: '/branch/tianjin'
      }, {
        name: '威海',
        path: '/branch/weihai'
      }, {
        name: '南京',
        path: '/branch/nanjing'
      }, {
        name: '宁波',
        path: '/branch/ningbo'
      }, {
        name: '武汉',
        path: '/branch/wuhan'
      }, {
        name: '长沙',
        path: '/branch/changsha'
      }, {
        name: '广州',
        path: '/branch/guangzhou'
      }, {
        name: '深圳',
        path: '/branch/shenzhen'
      }, {
        name: '日本',
        path: '/branch/riben'
      }, {
        name: '美国',
        path: '/branch/meiguo'
      }, {
        name: '澳大利亚',
        path: '/branch/aodaliya'
      }, {
        name: '中国香港',
        path: '/branch/xianggang'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.menu_container {
  height: 46px;
  width: 100%;
  background-color: #00439a;
  .menu_wrapper {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    .menu_ul {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      line-height: 46px;
      color: #ffffff;
      .menu_item {
        padding: 0 10px;
        flex: 1;
        box-sizing: border-box;
        text-align: center;
        &:hover {
          cursor: pointer;
          background-color: #01a1eb;
        }
        &.active {
          background-color: #01a1eb;
        }
      }
      .menu_network {
        padding: 0 10px;
        flex: 1;
        box-sizing: border-box;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
